// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `/* Player Profile Details modal - standalone (no paired team-list panel on
   this page), so it's simply centered. Styling ported from
   bssa-school-games-frontend's student-profile-modal.scss (flat, sectioned
   layout), trimmed to the parts this page actually uses. */
.modal-dialog.student-profile-modal {
  max-width: min(960px, 95vw) !important;
}

.pf-modal-header {
  display: flex;
  align-items: center;
  gap: 0.5rem;
}

.pf-modal-header .modal-title {
  flex: 1 1;
}

.student-profile-modal .modal-body > .container {
  max-width: none;
  padding: 0.75rem;
}

.student-profile-modal .modal-body > .container > .card {
  margin: 0 !important;
}

/* Player Profile Details form - flat, sectioned layout */
.pf-form {
  color: #1f2430;
}

.pf-form .pf-page-title {
  font-size: 1.15rem;
  font-weight: 700;
  text-align: center;
  padding: 0.75rem 1rem;
  margin-bottom: 1.5rem;
  border: 2px solid #e5e7eb;
  border-radius: 8px;
}

.pf-layout {
  display: grid;
  grid-template-columns: 210px 1fr;
  gap: 1.25rem;
}

@media (max-width: 767.98px) {
  .pf-layout {
    grid-template-columns: 1fr;
  }
}
.pf-sidebar {
  display: flex;
  flex-direction: column;
  gap: 0.85rem;
}

.pf-side-card {
  border: 1px solid #eef0f4;
  border-radius: 12px;
  padding: 0.85rem;
  background: #fff;
}

.pf-side-card h4 {
  font-size: 0.72rem;
  font-weight: 700;
  text-transform: uppercase;
  letter-spacing: 0.04em;
  color: #6b7280;
  margin-bottom: 0.65rem;
}

.pf-photo-card {
  position: relative;
  border-radius: 10px;
  overflow: hidden;
  background: #f4f5f8;
  aspect-ratio: 4/3;
  display: flex;
  align-items: center;
  justify-content: center;
}

.pf-photo-card img {
  width: 100%;
  height: 100%;
  object-fit: cover;
}

.pf-photo-placeholder {
  display: flex;
  flex-direction: column;
  align-items: center;
  gap: 0.4rem;
  color: #b3374a;
  font-size: 0.78rem;
  text-align: center;
  padding: 1rem;
}

.pf-photo-placeholder i {
  font-size: 1.75rem;
  color: #c5cad4;
}

.pf-doc-link {
  display: block;
  font-size: 0.85rem;
  margin-bottom: 0.4rem;
  color: #4f7cff;
  text-decoration: none;
  word-break: break-word;
}

.pf-doc-link:hover {
  text-decoration: underline;
}

.pf-doc-missing {
  font-size: 0.8rem;
  color: #d64550;
  margin-bottom: 0.5rem;
}

.pf-main {
  min-width: 0;
}

.pf-section {
  margin-bottom: 1.25rem;
}

.pf-section:last-child {
  margin-bottom: 0;
}

.pf-section-title {
  font-size: 0.9rem;
  font-weight: 700;
  color: #1f2430;
  margin-bottom: 0.75rem;
  padding-bottom: 0.4rem;
  border-bottom: 1px solid #eef0f4;
}

.pf-required {
  color: #e0384c;
}

.pf-grid {
  display: grid;
  grid-template-columns: repeat(auto-fit, minmax(200px, 1fr));
  gap: 0.85rem 1.25rem;
}

.pf-field--full {
  grid-column: 1/-1;
}

.pf-form .pf-field .form-label {
  display: block;
  font-size: 0.78rem;
  font-weight: 600;
  color: #4b5361;
  margin-bottom: 0.4rem;
}

.pf-form .pf-field .form-control,
.pf-form .pf-field .form-select {
  background-color: #f4f5f8;
  border: 1px solid transparent;
  border-radius: 8px;
  padding: 0.55rem 0.75rem;
  font-size: 0.88rem;
  color: #1f2430;
}

.pf-form .pf-field .form-control:focus,
.pf-form .pf-field .form-select:focus {
  background-color: #fff;
  border-color: #7c93ff;
  box-shadow: 0 0 0 3px rgba(124, 147, 255, 0.15);
}

.pf-form .pf-field .form-control[readonly],
.pf-form .pf-field .form-control:disabled {
  background-color: #eceef2;
  color: #6b7280;
}

.pf-gender-toggle {
  display: flex;
  gap: 1.25rem;
  align-items: center;
  height: calc(100% - 0.4rem);
  padding-top: 0.45rem;
}

.pf-error {
  color: #e0384c;
  font-size: 0.78rem;
  margin-top: 0.35rem;
  margin-bottom: 0;
}

.pf-actions {
  display: flex;
  justify-content: flex-end;
  gap: 0.6rem;
  margin-top: 0.85rem;
}

/* Shown in the profile pane while a newly-clicked player's data is being
   fetched, so the previous player's details never linger on screen. */
.pf-skel-line,
.pf-skel-input,
.pf-skel-photo {
  position: relative;
  overflow: hidden;
  background: #eceef2;
  border-radius: 6px;
}

.pf-skel-line::after,
.pf-skel-input::after,
.pf-skel-photo::after {
  content: "";
  position: absolute;
  inset: 0;
  transform: translateX(-100%);
  background: linear-gradient(90deg, rgba(255, 255, 255, 0) 0%, rgba(255, 255, 255, 0.6) 50%, rgba(255, 255, 255, 0) 100%);
  animation: pf-skel-shimmer 1.4s ease-in-out infinite;
}

.pf-skel-line {
  height: 0.7rem;
  width: 100%;
}

.pf-skel-label {
  height: 0.6rem;
  width: 50%;
  margin-bottom: 0.4rem;
}

.pf-skel-title {
  height: 0.85rem;
  margin-bottom: 0.75rem;
}

.pf-skel-input {
  height: 2.1rem;
  width: 100%;
  border-radius: 8px;
}

.pf-skel-photo {
  aspect-ratio: 4/3;
  width: 100%;
  border-radius: 10px;
}

.pf-skel-w-30 {
  width: 30%;
}

.pf-skel-w-50 {
  width: 50%;
}

.pf-skel-w-60 {
  width: 60%;
}

.pf-skel-w-70 {
  width: 70%;
}

.pf-skel-w-80 {
  width: 80%;
}

@keyframes pf-skel-shimmer {
  100% {
    transform: translateX(100%);
  }
}`, "",{"version":3,"sources":["webpack://./src/pages/dashboard/schooldashboard/studentProfile/student-profile-modal.scss"],"names":[],"mappings":"AAAA;;;2DAAA;AAUA;EACE,sCAAA;AALF;;AAQA;EACE,aAAA;EACA,mBAAA;EACA,WAAA;AALF;;AAQA;EACE,SAAA;AALF;;AAQA;EACE,eAAA;EACA,gBAAA;AALF;;AAQA;EACE,oBAAA;AALF;;AAQA,yDAAA;AAEA;EACE,cAAA;AANF;;AASA;EACE,kBAAA;EACA,gBAAA;EACA,kBAAA;EACA,qBAAA;EACA,qBAAA;EACA,yBAAA;EACA,kBAAA;AANF;;AASA;EACE,aAAA;EACA,gCAAA;EACA,YAAA;AANF;;AASA;EACE;IACE,0BAAA;EANF;AACF;AASA;EACE,aAAA;EACA,sBAAA;EACA,YAAA;AAPF;;AAUA;EACE,yBAAA;EACA,mBAAA;EACA,gBAAA;EACA,gBAAA;AAPF;;AAUA;EACE,kBAAA;EACA,gBAAA;EACA,yBAAA;EACA,sBAAA;EACA,cAAA;EACA,sBAAA;AAPF;;AAUA;EACE,kBAAA;EACA,mBAAA;EACA,gBAAA;EACA,mBAAA;EACA,iBAAA;EACA,aAAA;EACA,mBAAA;EACA,uBAAA;AAPF;;AAUA;EACE,WAAA;EACA,YAAA;EACA,iBAAA;AAPF;;AAUA;EACE,aAAA;EACA,sBAAA;EACA,mBAAA;EACA,WAAA;EACA,cAAA;EACA,kBAAA;EACA,kBAAA;EACA,aAAA;AAPF;;AAUA;EACE,kBAAA;EACA,cAAA;AAPF;;AAUA;EACE,cAAA;EACA,kBAAA;EACA,qBAAA;EACA,cAAA;EACA,qBAAA;EACA,sBAAA;AAPF;;AAUA;EACE,0BAAA;AAPF;;AAUA;EACE,iBAAA;EACA,cAAA;EACA,qBAAA;AAPF;;AAUA;EACE,YAAA;AAPF;;AAUA;EACE,sBAAA;AAPF;;AAUA;EACE,gBAAA;AAPF;;AAUA;EACE,iBAAA;EACA,gBAAA;EACA,cAAA;EACA,sBAAA;EACA,sBAAA;EACA,gCAAA;AAPF;;AAUA;EACE,cAAA;AAPF;;AAcA;EACE,aAAA;EACA,2DAAA;EACA,oBAAA;AAXF;;AAcA;EACE,iBAAA;AAXF;;AAcA;EACE,cAAA;EACA,kBAAA;EACA,gBAAA;EACA,cAAA;EACA,qBAAA;AAXF;;AAcA;;EAEE,yBAAA;EACA,6BAAA;EACA,kBAAA;EACA,wBAAA;EACA,kBAAA;EACA,cAAA;AAXF;;AAcA;;EAEE,sBAAA;EACA,qBAAA;EACA,+CAAA;AAXF;;AAcA;;EAEE,yBAAA;EACA,cAAA;AAXF;;AAcA;EACE,aAAA;EACA,YAAA;EACA,mBAAA;EACA,2BAAA;EACA,oBAAA;AAXF;;AAcA;EACE,cAAA;EACA,kBAAA;EACA,mBAAA;EACA,gBAAA;AAXF;;AAcA;EACE,aAAA;EACA,yBAAA;EACA,WAAA;EACA,mBAAA;AAXF;;AAcA;sEAAA;AAEA;;;EAGE,kBAAA;EACA,gBAAA;EACA,mBAAA;EACA,kBAAA;AAXF;;AAcA;;;EAGE,WAAA;EACA,kBAAA;EACA,QAAA;EACA,4BAAA;EACA,wHAAA;EAMA,oDAAA;AAhBF;;AAmBA;EACE,cAAA;EACA,WAAA;AAhBF;;AAmBA;EACE,cAAA;EACA,UAAA;EACA,qBAAA;AAhBF;;AAmBA;EACE,eAAA;EACA,sBAAA;AAhBF;;AAmBA;EACE,cAAA;EACA,WAAA;EACA,kBAAA;AAhBF;;AAmBA;EACE,iBAAA;EACA,WAAA;EACA,mBAAA;AAhBF;;AAmBA;EACE,UAAA;AAhBF;;AAkBA;EACE,UAAA;AAfF;;AAiBA;EACE,UAAA;AAdF;;AAgBA;EACE,UAAA;AAbF;;AAeA;EACE,UAAA;AAZF;;AAeA;EACE;IACE,2BAAA;EAZF;AACF","sourcesContent":["/* Player Profile Details modal - standalone (no paired team-list panel on\n   this page), so it's simply centered. Styling ported from\n   bssa-school-games-frontend's student-profile-modal.scss (flat, sectioned\n   layout), trimmed to the parts this page actually uses. */\n\n// Compound selector (rather than a bare .student-profile-modal rule) so this\n// reliably outranks Bootstrap's own `.modal-dialog { max-width: ... }` media\n// query rule of equal specificity - without it, whichever stylesheet loads\n// last wins the cascade, which previously left the dialog stuck at\n// Bootstrap's default (much narrower) width on some builds.\n.modal-dialog.student-profile-modal {\n  max-width: min(960px, 95vw) !important;\n}\n\n.pf-modal-header {\n  display: flex;\n  align-items: center;\n  gap: 0.5rem;\n}\n\n.pf-modal-header .modal-title {\n  flex: 1;\n}\n\n.student-profile-modal .modal-body > .container {\n  max-width: none;\n  padding: 0.75rem;\n}\n\n.student-profile-modal .modal-body > .container > .card {\n  margin: 0 !important;\n}\n\n/* Player Profile Details form - flat, sectioned layout */\n\n.pf-form {\n  color: #1f2430;\n}\n\n.pf-form .pf-page-title {\n  font-size: 1.15rem;\n  font-weight: 700;\n  text-align: center;\n  padding: 0.75rem 1rem;\n  margin-bottom: 1.5rem;\n  border: 2px solid #e5e7eb;\n  border-radius: 8px;\n}\n\n.pf-layout {\n  display: grid;\n  grid-template-columns: 210px 1fr;\n  gap: 1.25rem;\n}\n\n@media (max-width: 767.98px) {\n  .pf-layout {\n    grid-template-columns: 1fr;\n  }\n}\n\n.pf-sidebar {\n  display: flex;\n  flex-direction: column;\n  gap: 0.85rem;\n}\n\n.pf-side-card {\n  border: 1px solid #eef0f4;\n  border-radius: 12px;\n  padding: 0.85rem;\n  background: #fff;\n}\n\n.pf-side-card h4 {\n  font-size: 0.72rem;\n  font-weight: 700;\n  text-transform: uppercase;\n  letter-spacing: 0.04em;\n  color: #6b7280;\n  margin-bottom: 0.65rem;\n}\n\n.pf-photo-card {\n  position: relative;\n  border-radius: 10px;\n  overflow: hidden;\n  background: #f4f5f8;\n  aspect-ratio: 4 / 3;\n  display: flex;\n  align-items: center;\n  justify-content: center;\n}\n\n.pf-photo-card img {\n  width: 100%;\n  height: 100%;\n  object-fit: cover;\n}\n\n.pf-photo-placeholder {\n  display: flex;\n  flex-direction: column;\n  align-items: center;\n  gap: 0.4rem;\n  color: #b3374a;\n  font-size: 0.78rem;\n  text-align: center;\n  padding: 1rem;\n}\n\n.pf-photo-placeholder i {\n  font-size: 1.75rem;\n  color: #c5cad4;\n}\n\n.pf-doc-link {\n  display: block;\n  font-size: 0.85rem;\n  margin-bottom: 0.4rem;\n  color: #4f7cff;\n  text-decoration: none;\n  word-break: break-word;\n}\n\n.pf-doc-link:hover {\n  text-decoration: underline;\n}\n\n.pf-doc-missing {\n  font-size: 0.8rem;\n  color: #d64550;\n  margin-bottom: 0.5rem;\n}\n\n.pf-main {\n  min-width: 0;\n}\n\n.pf-section {\n  margin-bottom: 1.25rem;\n}\n\n.pf-section:last-child {\n  margin-bottom: 0;\n}\n\n.pf-section-title {\n  font-size: 0.9rem;\n  font-weight: 700;\n  color: #1f2430;\n  margin-bottom: 0.75rem;\n  padding-bottom: 0.4rem;\n  border-bottom: 1px solid #eef0f4;\n}\n\n.pf-required {\n  color: #e0384c;\n}\n\n// auto-fit + a minimum track width means a field is never squeezed narrower\n// than it can legibly render (the previous fixed repeat(2, 1fr) let a 210px\n// sidebar + narrow modal combination crush each column to the point that\n// input text was clipped) - columns simply wrap to fewer per row instead.\n.pf-grid {\n  display: grid;\n  grid-template-columns: repeat(auto-fit, minmax(200px, 1fr));\n  gap: 0.85rem 1.25rem;\n}\n\n.pf-field--full {\n  grid-column: 1 / -1;\n}\n\n.pf-form .pf-field .form-label {\n  display: block;\n  font-size: 0.78rem;\n  font-weight: 600;\n  color: #4b5361;\n  margin-bottom: 0.4rem;\n}\n\n.pf-form .pf-field .form-control,\n.pf-form .pf-field .form-select {\n  background-color: #f4f5f8;\n  border: 1px solid transparent;\n  border-radius: 8px;\n  padding: 0.55rem 0.75rem;\n  font-size: 0.88rem;\n  color: #1f2430;\n}\n\n.pf-form .pf-field .form-control:focus,\n.pf-form .pf-field .form-select:focus {\n  background-color: #fff;\n  border-color: #7c93ff;\n  box-shadow: 0 0 0 3px rgba(124, 147, 255, 0.15);\n}\n\n.pf-form .pf-field .form-control[readonly],\n.pf-form .pf-field .form-control:disabled {\n  background-color: #eceef2;\n  color: #6b7280;\n}\n\n.pf-gender-toggle {\n  display: flex;\n  gap: 1.25rem;\n  align-items: center;\n  height: calc(100% - 0.4rem);\n  padding-top: 0.45rem;\n}\n\n.pf-error {\n  color: #e0384c;\n  font-size: 0.78rem;\n  margin-top: 0.35rem;\n  margin-bottom: 0;\n}\n\n.pf-actions {\n  display: flex;\n  justify-content: flex-end;\n  gap: 0.6rem;\n  margin-top: 0.85rem;\n}\n\n/* Shown in the profile pane while a newly-clicked player's data is being\n   fetched, so the previous player's details never linger on screen. */\n.pf-skel-line,\n.pf-skel-input,\n.pf-skel-photo {\n  position: relative;\n  overflow: hidden;\n  background: #eceef2;\n  border-radius: 6px;\n}\n\n.pf-skel-line::after,\n.pf-skel-input::after,\n.pf-skel-photo::after {\n  content: \"\";\n  position: absolute;\n  inset: 0;\n  transform: translateX(-100%);\n  background: linear-gradient(\n    90deg,\n    rgba(255, 255, 255, 0) 0%,\n    rgba(255, 255, 255, 0.6) 50%,\n    rgba(255, 255, 255, 0) 100%\n  );\n  animation: pf-skel-shimmer 1.4s ease-in-out infinite;\n}\n\n.pf-skel-line {\n  height: 0.7rem;\n  width: 100%;\n}\n\n.pf-skel-label {\n  height: 0.6rem;\n  width: 50%;\n  margin-bottom: 0.4rem;\n}\n\n.pf-skel-title {\n  height: 0.85rem;\n  margin-bottom: 0.75rem;\n}\n\n.pf-skel-input {\n  height: 2.1rem;\n  width: 100%;\n  border-radius: 8px;\n}\n\n.pf-skel-photo {\n  aspect-ratio: 4 / 3;\n  width: 100%;\n  border-radius: 10px;\n}\n\n.pf-skel-w-30 {\n  width: 30%;\n}\n.pf-skel-w-50 {\n  width: 50%;\n}\n.pf-skel-w-60 {\n  width: 60%;\n}\n.pf-skel-w-70 {\n  width: 70%;\n}\n.pf-skel-w-80 {\n  width: 80%;\n}\n\n@keyframes pf-skel-shimmer {\n  100% {\n    transform: translateX(100%);\n  }\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
